<template>
  <div class="box mt-5">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3> Suppliers, Services & Payments </h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10"></div>
          <div class="col-md-2">
            <div class="form">
              <div>
                <label for="is-special-opt_out_from_emails">Calculate revenue</label>
                <label class="switch">
                  <input id="opt_out_from_emails" type="checkbox" v-model="calculate_revenue" @change="getBookingGrossRevenue">
                  <span class="switch__slider"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row p-3 mt-3">
          <div class="col-md-4"></div>
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-6"><h5 style="float: right;">Gross Revenue : </h5></div>
                  <div class="col-md-6"><h5> {{ grossRevenue | formatCurrency }}</h5></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-8"><h5 style="float: right;">Cancellation Revenue : </h5></div>
                  <div class="col-md-4"><h5> {{ cancellationRevenue | formatCurrency }}</h5></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-6"><h5 style="float: right;">Tour Profit : </h5></div>
                  <div class="col-md-6"><h5> {{ netRevenue | formatCurrency }}</h5></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <hr>
        <div class="row">
          <div class="col-md-12">
            <form class="form" v-on:submit.prevent="recordInternalPayment">
              <fieldset>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-wrap">
                    <div>
                      <label for="group_supplier">Payment for</label>
                      <v-select
                        label="label"
                        id="payment_for"
                        :options="[
                          {
                            id:1,
                            slug:'supllier',
                            label:'Supplier'
                          },
                          {
                            id:2,
                            slug:'tour_manager',
                            label:'Tour Manager'
                          },
                        ]"
                        index="id"
                        placeholder="Select Payment for"
                        v-model="payment.payment_for"
                        required
                      />
                    </div>
                    <div v-if="payment.payment_for == '1'">
                      <label for="group_supplier">Supplier</label>
                      <v-select
                        label="supplier_name"
                        id="group_supplier"
                        :options="suppliers"
                        index="id"
                        placeholder="Select Supplier"
                        v-model="payment.group_supplier"
                        @change="getSupplierInvoices('supplier')"
                        required
                      />
                    </div>
                    <div v-else-if="payment.payment_for == '2'">
                      <label for="group_supplier">Tour Manager</label>
                      <v-select
                        label="firstname"
                        id="tour_manager"
                        :options="tourManagers"
                        index="id"
                        placeholder="Select Tour manager"
                        v-model="payment.tour_manager"
                        @change="getSupplierInvoices('tour_manager')"
                        required
                      />
                    </div>
                    
                    <div>
                      <label for="group_service_type">Service Type</label>
                      <v-select
                        label="service_name"
                        id="group_service_type"
                        :options="servicesTypes"
                        placeholder="Select Service type"
                        v-model="payment.group_service_type"
                        required
                      />
                    </div>
                    
                    <div v-if="payment.group_service_type && payment.group_service_type.service_name.toLowerCase() == 'accommodation'">
                      <label for="group_service_type">Select Accomodation</label>
                      <v-select
                        label="accommodation_name"
                        id="supplier_accomodations"
                        :options="supplierAccomodations"
                        placeholder="Select Accomodation"
                        v-model="selected_Accomodation"
                        @change="setAccomodationRoom"
                        required
                      />
                    </div>
                    <div v-if="payment.group_service_type && payment.group_service_type.service_name.toLowerCase() == 'accommodation'">
                      <label for="accommodation_room"> Accomodation Room </label>
                      <v-select
                        label="name"
                        id="accommodation_room"
                        :options="accomodation_room_list"
                        v-model="payment.selectected_accomodation_room_id"
                        @change="fetchSupplierEstimatedCost"
                        placeholder="Select Accomodation Room"
                        index="id"
                        multiple
                        required
                      />
                    </div>

                    <div>
                      <label for="estimated_cost">Estimated Cost</label>
                      <input id="estimated_cost" type="number" step="0.01" placeholder="Estimated Cost" v-model="payment.estimated_cost">
                    </div>  
                    <div>
                        <label for="group_supplier">Currency Type</label>
                        <v-select
                            id="currency_type"
                            :options="currencyTypes"
                            label="name"
                            placeholder="Select Currency Type"
                            v-model="selected_estimated_currency_type"
                            @change="selectCurrency"
                            required
                        />
                        <small class="text-danger"></small>
                    </div>
                    <div>
                        <label for="exchange_rate"> Exchange rate </label>
                        <input id="exchange_rate" type="text" placeholder="Exchange rate" v-model="payment.currency_exchange_rate">
                        <small class="text-primary" v-if="payment.currency_type && payment.currency_exchange_rate"> 1 {{ payment.currency_type }} = {{ payment.currency_exchange_rate }} Sterling</small>
                    </div>
                    <div>
                      <label for="is-special-instance">Per Person basis ? </label>
                      <label class="switch">
                        <input id="is-special-instance" type="checkbox" v-model="payment.per_person_basis" >
                        <span class="switch__slider"></span>
                      </label>  
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-wrap">
                    <div>
                      <label for="invoice_number">Invoice Number </label>
                      <!-- <input id="invoice_number" type="text" placeholder="Invoice Number"  v-model="payment.invoice_number"> -->
                      <v-select
                          id="invoice_number"
                          :options="supplier_invoices"
                          placeholder="Select Invoice"
                          v-model="payment.supplier_invoice"
                          label="invoice_number"
                          required
                      />
                    </div>
      
                    <div>
                      <label for="invoice_amount">Invoice Amount</label>
                      <input id="invoice_amount" 
                              type="number" 
                              step="0.01"
                              placeholder="Invoice Paid Amount" 
                              @keyup="checkInvoiceAmount" 
                              v-model="payment.invoice_asigned_amount"
                              :disabled="(!payment.supplier_invoice) ? true: false ">
                      <small v-if="payment_error.invoice_amount" class="text-danger">{{ payment_error.invoice_amount }}</small>
                    </div>
                  
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-wrap">
                    <div class="form-submit-inline">
                      <button type="submit" class="button" :disabled="!canSubmit">
                        <span> {{(payment.flag =='add' ? 'Add' : 'Update')}} Payment </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              </fieldset>
            </form>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-12">
            <table class="table" cellspacing="0">
              <thead>
                <tr>
                  <th>Supplier/Tour Manager</th>
                  <th>Service type</th>
                  <th>Estimated amount</th>
                  <th>Invoice amount</th>
                  <th>Invoice Details</th>
                  <th>Due Date</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <template v-if="tourInternalPayments.length > 0 ">
                  <tr v-for="group_payment in tourInternalPayments" :key="group_payment.id" :class="(group_payment.tour_group_payment_id === payment.tour_group_payment_id) ? 'highlighted-row' : '' ">
                    <td>
                      <template v-if="group_payment.supplier">
                        <router-link :to="{ name: 'supplier-edit', params: { id: group_payment.supplier_id }}" class="color-orange">
                          {{ group_payment.supplier.supplier_name }}
                        </router-link>
                        
                      </template>
                      <template v-else-if="group_payment.tour_manager">
                        <router-link :to="{ name: 'edit-tour-manager', params: { id: group_payment.tour_manager_id }}" class="color-orange">
                          {{ `${group_payment.tour_manager.firstname} ${group_payment.tour_manager.lastname}` }}
                        </router-link>
                      </template>
                      <template v-else>--</template>
                    </td>
                    <td>
                      {{ (group_payment.service_types ? group_payment.service_types.service_name : '--')}} <br/>
                      <template v-if="group_payment.accomodation">
                          <small>{{ group_payment.accomodation.accommodation_name }} </small>
                          <br>
                          <ul v-for="room in group_payment.accomodation.accommodation_rooms" :key="room.id">
                            <li v-if="group_payment.accomodation_room_id.includes(room.id)">
                              <small>{{ room.name }} - {{ room.board_basis }}</small>
                            </li>
                          </ul>
                       
                      </template>
                    </td>
                    <td>
                      <template v-if="group_payment.estimated_cost">
                          {{ showGroupPaymentEstimatedCost(group_payment,groupPassengerCount) | formatCurrency }}
                      </template>
                    </td>
                    <td>
                      <template v-if="group_payment.invoice_amount && group_payment.supplier_invoice.length == 1">
                        {{ Number(group_payment.invoice_amount/group_payment.supplier_invoice[0].currency_exchange_rate) | formatCurrency }}
                      </template>
                      <template v-else>--</template>
                    </td>
                    <td>
                      <template v-if="group_payment.supplier_invoice.length == 1 && group_payment.supplier_invoice[0].payment_invoice_path">
                        <a href="javascript:void(0)" @click="downloadInvoice(group_payment.supplier_invoice[0].id,group_payment.supplier_invoice[0].payment_invoice_name)" class="color-orange">({{ group_payment.supplier_invoice[0].invoice_number }})- {{ group_payment.supplier_invoice[0].payment_invoice_name }}</a>
                      </template>
                      <template v-else> -- </template>
                    </td>
                    <td>
                      <template v-if="group_payment.supplier_invoice.length == 1 && group_payment.supplier_invoice[0].payment_due_date">
                        {{ group_payment.supplier_invoice[0].payment_due_date | formatDate }}
                      </template>
                      <template v-else>--</template>
                    </td>
                    <td class="table-action"><a v-on:click="editInternalPayment(group_payment.tour_group_payment_id)" class="icon icon--more">Edit</a></td>
                    <td class="table-action"><a class="icon icon--delete" v-on:click="deleteInternalPayment(group_payment.tour_group_payment_id, $route.params.id)">Delete</a></td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="6" class="text-center"> 
                      <h4>No data available.</h4>
                    </td>
                  </tr>
                </template>
                
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'TourGroupInternalPayments',
  props: {
    suppliers:Array,
    servicesTypes:Array,
    tourManagers:Array,
    tourInternalPayments:Array,
    grossRevenue: Number,
    cancellationRevenue:Number
  },
  data () {
    return {
      currencyTypes: [],
      selected_estimated_currency_type: {},
      payment : {
        flag: 'add',
        group_supplier:null,
        supplier_invoice:null,
        group_service_type:null,
        estimated_cost: null,
        currency_type: 'Sterling',
        currency_exchange_rate: 1,
        per_person_basis : null,
        invoice_asigned_amount: null,
        selected_Accomodation_id: null,
        selectected_accomodation_room_ids:[],
      },
      onEditInvoiceNumber: null,
      payment_error: {
        invoice_amount: null,
        
      },
      selected_service_type: {},
      canSubmit:true,
      groupPassengerCount:0,
      paymentsDone: [],
      supplier_invoices: [],
      calculate_revenue: false,
      supplierAccomodations: [],
      selected_Accomodation: {},
      accomodation_room_list: [],
      
    }
  },
  watch: {
    
  },
  created() {
    this.getCurrencyExchangeRate()
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    netRevenue(){
      let revenue = this.grossRevenue;
      let cancellation_revenue = this.cancellationRevenue
      let passengerCount = 0;
      let bookings = this.$parent.group.bookings;

      if (bookings.length > 0 ) {
        bookings.forEach(
          (element) => {
            if (['Paid', 'Confirmed'].includes(element.booking_status)) {
              // First Preferecne will be for Passengers
              if (element.passengers.length > 0 ) {
                passengerCount += element.passengers.length
              }
              // if zero Passengers than calculate based on tour guests
              else {
                passengerCount += element.guests
              }
            }
          })
      }

      this.groupPassengerCount = passengerCount;

      let calculated_amount = 0;
      if (this.tourInternalPayments.length > 0 ){
        this.tourInternalPayments.forEach(element => {

          let invoice_amount = Number(element.invoice_amount)
          let estimated_cost = Number(element.estimated_cost)

          if (invoice_amount > 0) {
            if (element.supplier_invoice.length > 0 && element.supplier_invoice[0].currency_exchange_rate) {
              calculated_amount += invoice_amount / (Number(element.supplier_invoice[0].currency_exchange_rate))
            }
          } else if (estimated_cost > 0) {
            calculated_amount += (element.per_person_basis) ? passengerCount * estimated_cost : estimated_cost
          }

        });
      } 

      let final_revenue = (revenue + cancellation_revenue) - calculated_amount
      return (final_revenue > 0) ? final_revenue : 0;
    },
  },
  methods: {
    getCurrencyExchangeRate() {
      fetch(this.$api + 'currency-exchange/get-current-list', {
          headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
      })
      .then(res => res.json())
      .then(response => {
          this.errors = response.errors
          if(response.status) {
              this.currencyTypes = response.data
          }
      });
    },
    selectCurrency() {
      if (this.selected_estimated_currency_type) {
        this.payment.currency_type = this.selected_estimated_currency_type.name;
        this.payment.currency_exchange_rate = this.selected_estimated_currency_type.exchange_rate
      } else {
        this.payment.currency_type = null;
        this.payment.currency_exchange_rate = null
      }
    },
    showGroupPaymentEstimatedCost(group_payment, group_passenger_count) {
      let payment = 0;
      if (group_payment.per_person_basis) {
        if (group_payment.currency_exchange_rate) {
          payment = Number(group_payment.estimated_cost / group_payment.currency_exchange_rate) * group_passenger_count
        } else {
          payment = Number(group_payment.estimated_cost) * group_passenger_count
        }
      } else {
        if (group_payment.currency_exchange_rate) { 
          payment = Number(group_payment.estimated_cost / group_payment.currency_exchange_rate)
        } else {
          payment = Number(group_payment.estimated_cost)
        }
      }

      return payment;
    },
    checkInvoiceAmount() {
      let leftInvoiceAmount = Number(this.payment.supplier_invoice.invoice_amount)
      if (Number(this.payment.invoice_asigned_amount) > Number(leftInvoiceAmount)) {
        this.payment_error.invoice_amount = `Please provide valid invoice amount less than ${leftInvoiceAmount}`  
        this.canSubmit = false
      } else {
        this.payment_error.invoice_amount = null 
        this.canSubmit = true
        
      }
    },
    recordInternalPayment() {
      // Check validations
      let This = this
      this.checkValidation().then(function (response) {

        This.$store.dispatch('setLoadStatus')
  
        let group_id = This.$route.params.id
  
        fetch(`${This.$api}tours/groups/${group_id}/handle-internal-payments`, {
            method: 'POST',
            body: JSON.stringify(This.payment),
            headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
            }
        })
        .then(res => res.json())
        .then(response => {
          This.errors = response.errors
          if(response.status) {
              This.$notify({
                  type: 'success',
                  title: response.message
              });
              This.payment = {
                flag:'add',
              }
              This.$emit('handle-new-payment', response.payment_done)
          } else if (response.errors) {
              This.$notify({
                  type: 'error',
                  title: response.message
              });
          }
          This.$store.dispatch('setLoadStatus')
        });
      })
      .catch(error => console.log(error))
          
    },
    editInternalPayment(payment_id){
      let foundPayment = this.tourInternalPayments.find(element => element.tour_group_payment_id == payment_id)
      if (foundPayment) {
        this.payment = {}
        
        this.payment.flag = 'edit'
        this.payment.id = foundPayment.tour_group_payment_id
        this.payment.selected_Accomodation_id = foundPayment.accomodation_id
        this.payment.selectected_accomodation_room_id = foundPayment.accomodation_room_id

        this.payment.payment_for = (foundPayment.supplier_id) ? 1 : 2
        this.payment.tour_group_payment_id = foundPayment.tour_group_payment_id
        
        this.payment.group_supplier = (foundPayment.supplier_id) ? foundPayment.supplier_id : null
        this.payment.tour_manager = (foundPayment.tour_manager_id) ? foundPayment.tour_manager_id : null
        this.payment.currency_exchange_rate = foundPayment.currency_exchange_rate
        this.payment.invoice_asigned_amount = foundPayment.invoice_amount
        this.payment.per_person_basis = foundPayment.per_person_basis

        if (foundPayment.supplier_invoice.length == 1) {
          this.onEditInvoiceNumber = foundPayment.supplier_invoice[0].id
        }

        // this.payment.group_service_type = Number(foundPayment.service_type)
        this.payment.group_service_type = this.servicesTypes.find(element => element.service_type_id == foundPayment.service_type)
        this.selected_estimated_currency_type = this.currencyTypes.find(element => element.name == foundPayment.currency_type)
        this.payment.estimated_cost = foundPayment.estimated_cost
      }
    },
    deleteInternalPayment (payment_id, group_id) {
      this.$dialog
      .confirm(`Are you sure you want to delete payment ?`)
      .then(() => {
        this.$store.dispatch('setLoadStatus')
        fetch(`${this.$api}tours/groups/${group_id}/delete-internal-payments/${payment_id}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if(response.status) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$emit('handle-new-payment', response.payment_done)
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          } else {
            this.$notify({
              type: 'error',
              title: response.Error
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      }).catch(() => {
        this.$store.dispatch('setLoadStatus')
        console.log('Clicked on cancel');
      });
    },
    checkValidation() {
      // let This = this
      
      return new Promise((resolve, reject) => {

        // if (!This.payment.currency_type) {
        //   This.payment_error.currency_type = "Please select currency type"
        //   This.canSubmit = false
        // } else {
        //   This.payment_error.currency_type = ""
        //   This.canSubmit = true
        // }
        // if (!This.payment.currency_exchange_rate) {
        //   This.payment_error.currency_exchange_rate = "Please provide exchange rate"
        //   This.canSubmit = false
        // } else {
        //   This.payment_error.currency_exchange_rate = ""
        //   This.canSubmit = true
        // }
        resolve()

        // if (This.canSubmit) {
        // } else {
        //   reject()
        // }
      })
    },
    getSupplierInvoices(invoice_for) {

      let invoice_for_id = null
      if (invoice_for == 'supplier') {
        invoice_for_id = this.payment.group_supplier 
      } else if (invoice_for == 'tour_manager') {
        invoice_for_id = this.payment.tour_manager
      }

      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}suppliers/invoice/get-supplier-invoices`, {
          method: 'POST',
          body: JSON.stringify({
            invoice_for,
            invoice_for_id
          }),
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.status) {
            this.supplier_invoices = response.data.invoices
            this.supplierAccomodations = response.data.supplier_accomodations
            if (this.onEditInvoiceNumber) {
              let foundInvoice = this.supplier_invoices.find(element => element.id == this.onEditInvoiceNumber)
              if (foundInvoice) {
                this.payment.supplier_invoice = foundInvoice
              }
            }

            if (this.payment.flag == 'edit' && this.payment.selected_Accomodation_id) {
              this.selected_Accomodation = this.supplierAccomodations.find(element => element.id == this.payment.selected_Accomodation_id)
              this.accomodation_room_list = this.selected_Accomodation.accommodation_rooms
            }

          } else if (response.errors) {
              this.$notify({
                  type: 'error',
                  title: response.message
              });
          }
          this.$store.dispatch('setLoadStatus')
        }).catch(() => {
          this.$store.dispatch('setLoadStatus')
          console.log('Clicked on cancel');
        });;
    },
    downloadInvoice(payment_id, invoice_name) {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}suppliers/download-internal-payment-invocie/${payment_id}`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
      })
      .then((res) => {
      if(res.status === 200) {
          this.$store.dispatch('setLoadStatus')
          res.blob().then(response => {
              const _url = window.URL.createObjectURL(response)
              const link = document.createElement('a')
              link.href = _url
              link.setAttribute('download', invoice_name)
              document.body.appendChild(link)
              link.click();
          })
      } else {
          this.$store.dispatch('setLoadStatus')
          Promise.race([res.json()])
          .then(response => {
          if(response.message) {
              this.$notify({
              type: 'error',
              title: response.message
              });
          } else {
              this.$notify({
              type: 'error',
              title: response.error
              });
          }
          })
      }
      });
    },
    getBookingGrossRevenue() {
      if (this.calculate_revenue) {
        this.$store.dispatch('setLoadStatus')
        fetch(`${this.$api}tours/groups/${this.$route.params.id}/calculate-revenue`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if (response.status) {
            this.$emit('updateRevenue', {
              gross_revenue : response.data.gross_revenue,
              cancellation_revenue : response.data.cancellation_revenue
            })
          } 
          this.$store.dispatch('setLoadStatus')
        });
      } else {
        this.$emit('updateRevenue', {
          gross_revenue : 0,
          cancellation_revenue : 0
        })
      }
    },
    setAccomodationRoom() {

      if ('id' in this.selected_Accomodation && 'accommodation_rooms' in this.selected_Accomodation) {
        this.payment.selected_Accomodation_id = this.selected_Accomodation.id
        this.accomodation_room_list = [];
        this.accomodation_room_list.push({
          id:0,
          name: 'All',
          accommodation_id : 0,
          board_basis : null,
          occupancy : null ,
          is_special : null ,
        })
        this.selected_Accomodation.accommodation_rooms.forEach(element => this.accomodation_room_list.push(element))
      } 
    },
    fetchSupplierEstimatedCost() {
      if (this.payment.selectected_accomodation_room_id.indexOf(0) !== -1) {
        this.payment.selectected_accomodation_room_id = this.selected_Accomodation.accommodation_rooms.map(element => element.id)
      }
      let { group_supplier, payment_for, selected_Accomodation_id, selectected_accomodation_room_id } = this.payment
      if (group_supplier && payment_for == 1 && selected_Accomodation_id && selectected_accomodation_room_id) {
        this.$store.dispatch('setLoadStatus')
        fetch(`${this.$api}tours/groups/${this.$route.params.id}/fetch-supplier-estimated-cost`, {
          method: 'POST',
          body: JSON.stringify({
            accomodation_id:selected_Accomodation_id,
            accomodation_room_id:selectected_accomodation_room_id
          }),
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          this.errors = response.errors
          if (response.status) {
            this.payment.estimated_cost = response.estimated_cost
            this.selected_estimated_currency_type = response.currency
          } 
          this.$store.dispatch('setLoadStatus')
        });
      }
    }
  }
}
</script>
<style scoped>
::v-deep .highlighted-row {
  background-color: #4477fb63 !important;
  border-left: 4px solid #ec391e !important;
  --bs-table-accent-bg: #4477fb63 !important;
}

::v-deep .highlighted-row:hover {
  background-color: #4477fb63 !important;
}
</style>